import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { MemoryCountDownContext } from "../Context/MemoryCountDownContext";


const CountDown = ({countTime}) => {
    const {updateCountDown} = useContext(MemoryCountDownContext);
    const [counter, setCounter] = useState(countTime);

    useEffect(() => {
        if(counter > 0){
            setTimeout(() => setCounter(counter - 1), 1000);
        } else{
            setCounter("Kör");
            setTimeout(() => {updateCountDown(true)}, 1000 );
        }
    }, [counter]);

    return(
        counter
    );
};

export default CountDown;
